"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarContext = void 0;
const react_1 = require("react");
exports.SnackbarContext = (0, react_1.createContext)({
    showSnackbar: () => {
        console.error('Snackbar context is not created. Wrap your application with SnackbarProvider.');
    },
});
//# sourceMappingURL=snackbar-context.js.map